/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_Primary_Content_LabelInputs */

const en_admin_design_settings_primary_content_label = /** @type {(inputs: Admin_Design_Settings_Primary_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text color on primary`)
};

const de_admin_design_settings_primary_content_label = /** @type {(inputs: Admin_Design_Settings_Primary_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftfarbe auf Primärfarbe`)
};

/**
* | output |
* | --- |
* | "Text color on primary" |
*
* @param {Admin_Design_Settings_Primary_Content_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_primary_content_label = /** @type {((inputs?: Admin_Design_Settings_Primary_Content_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_Primary_Content_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_primary_content_label(inputs)
	return en_admin_design_settings_primary_content_label(inputs)
});